import { Component, ChangeDetectionStrategy } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { UserQualificationV2 } from '@wilson/interfaces';
import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { NzTagModule } from 'ng-zorro-antd/tag';

export interface OnClickRendererParams extends ICellRendererParams {
  onClick?: (event: MouseEvent, data: UserQualificationV2) => void;
}

@Component({
  selector: 'wilson-signed-by-user-icon-renderer',
  template: `
    <div class="cursor-pointer" (click)="onClick($event)">
      @if (cellValue) {
        <nz-tag nzColor="success">{{
          'page.qualifications.confirmed' | translate
        }}</nz-tag>
      } @else {
        <nz-tag nzColor="warning">{{
          'page.qualifications.not_confirmed' | translate
        }}</nz-tag>
      }
    </div>
  `,
  styles: [],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NzTagModule, TranslatePipe],
})
export class ConfirmedByUserRendererComponent implements AgRendererComponent {
  public cellValue!: boolean;
  params!: OnClickRendererParams;

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.cellValue = this.getValueToDisplay(params);
  }

  refresh(params: ICellRendererParams): boolean {
    this.params = params;
    this.cellValue = this.getValueToDisplay(params);
    return true;
  }

  getValueToDisplay(params: ICellRendererParams): boolean {
    return params.data?.confirmedByUser;
  }

  onClick(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();
    if (this.params?.onClick) {
      this.params.onClick(event, this.params.data);
    }
  }
}
